var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatbubbleTypingFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M9.891 1.243a10.96 10.96 0 0 1 6.864.884 10.959 10.959 0 1 1-9.33 19.83l-5.463.985a.79.79 0 0 1-.876-1.05l1.565-4.169a10.96 10.96 0 0 1 7.24-16.48m-2.623 9.18a1.576 1.576 0 1 0 0 3.151 1.576 1.576 0 0 0 0-3.151m4.728 0a1.576 1.576 0 1 0-.001 3.151 1.576 1.576 0 0 0 0-3.151m4.727 0a1.575 1.575 0 1 0-.001 3.15 1.575 1.575 0 0 0 .001-3.15"
})));
export default SvgChatbubbleTypingFill;